import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
    getData<T> (key: string): T {
        let text = window.localStorage.getItem(key);
        return JSON.parse(text);
    }

    setData (key: string, data: any) {
        let text = JSON.stringify(data);
        try {
            window.localStorage.setItem(key, text);
            return true;
        }
        catch(error) {
            console.log("Cannot set local storage data:");
            console.log(data);
            return false;
        }
    }

    removeData (key: string) {
        try {
            window.localStorage.removeItem(key);
            return true;
        }
        catch(error) {
            console.log("Cannot remove local storage data. Data key: " + key);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/LocalStorageService.ts